export default "__VITE_ASSET__v37cceks__"